import { Colors } from 'styles/colors'
import './anchorPart.scss'

export interface IAnchor {
   partName: string
   id: number
}

interface IProps {
   anchor: IAnchor
}

export default function AnchorPart({ anchor }: IProps) {
   return (
      <div
         className='anchor'
         id={String(anchor.id)}
         style={{ color: Colors.white, fontSize: '30px', fontFamily: 'Helvetica Neue Boldext' }}
      >
         {anchor.partName}
      </div>
   )
}
